export default "__VITE_ASSET__BUpnBPb2__"